<template>
  <v-row>
    <!-- toolbar -->
    <v-col cols="12">
      <v-toolbar dense flat rounded color="primary" dark>
        <v-toolbar-title class="text-capitalize">{{
          $route.path.replace("/", "").replaceAll("-", " ")
        }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-title v-if="items.length"
          ><span>{{ items.length ? items.length : "" }} Items</span>
          <span class="d-inline-clock mx-5"
            >{{
              items && items.length && items.filter((i) => !i.isPaid).length
                ? items.filter((i) => !i.isPaid).length
                : ""
            }}
            Unpaid</span
          >
          <span
            >({{
              items && items.length && items.filter((i) => !i.isPaid).length
                ? formatCurrency(
                    items
                      .filter((i) => !i.isPaid)
                      .map((i) => parseInt(i.eventReportTotal))
                      .reduce((a, b) => a + b)
                  )
                : ""
            }})</span
          ></v-toolbar-title
        >
      </v-toolbar>
    </v-col>

    <!-- table -->
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        dense
        :items="items"
        class="elevation-1"
        :loading="loading"
        sortBy="eventReportNumber"
        :sortDesc="true"
        :items-per-page="itemsPerPage"
        :search="search"
        :footer-props="{
          'items-per-page-options': [15, 50, 100, -1],
          'show-current-page': true,
        }"
        @click:row="onEdit"
        show-expand
        single-expand
        :expanded.sync="expanded"
      >
        <!-- top -->
        <template v-slot:top>
          <div class="pa-4 d-flex">
            <v-btn
              fab
              color="primary"
              depressed
              small
              @click="
                searching = !searching;
                !searching && search ? (search = '') : '';
              "
              :loading="loading"
              :disabled="loading"
            >
              <v-icon>
                {{ searching ? "mdi-close" : "mdi-magnify" }}
              </v-icon></v-btn
            >
            <div style="width: 500px">
              <v-slide-x-transition>
                <v-text-field
                  v-show="searching"
                  label="Search"
                  v-model="search"
                  outlined
                  dense
                  hide-details
                  clearable
                  class="ml-5"
                  filled
                  autofocus
                  :loading="loading"
                  :disabled="loading"
                ></v-text-field>
              </v-slide-x-transition>
            </div>
            <v-spacer />
            <!-- <v-btn
              color="primary"
              depressed
              style="margin-right: 10px"
              :loading="loading"
              :disabled="loading || isValidQBConnection"
              @click="quickBookConnect"
              >QB Connect</v-btn
            > -->
            <v-btn
              fab
              color="primary"
              depressed
              small
              style="margin-top: -3px"
              :loading="loading"
              :disabled="loading"
              @click="
                itemDialog = true;
                editing = false;
                $set(item, 'id', '');
                $set(item, 'eventReportTotal', 0);
                $set(item, 'winners', [
                  {
                    costToOrg: '',
                    destination: '',
                    isRegistered: false,
                    lastName: '',
                    numberNights: '',
                    packageCode: '',
                    packageID: '',
                    unitType: '',
                    travelByDate: '',
                  },
                ]);
                justAddedWinnerAlert = true;
                $refs.form ? $refs.form.resetValidation() : '';
                expanded = [];
              "
            >
              <v-icon> mdi-plus </v-icon>
            </v-btn>
          </div>
        </template>

        <!-- items -->
        <template v-slot:[`item.eventDate`]="{ item }">
          {{ formatDate(item.eventDate, "MM/DD/YYYY") }}
        </template>
        <template v-slot:[`item.isPaid`]="{ item }">
          <v-icon small :color="item.isPaid ? 'success' : 'error'">
            {{ item.isPaid ? "mdi-check" : "mdi-close" }}
          </v-icon>
        </template>
        <template v-slot:[`item.qbSync`]="{ item }">
          <v-icon small :color="item.qbSync ? 'success' : 'error'">
            {{ item.qbSync ? "mdi-check" : "mdi-close" }}
          </v-icon>
        </template>
        <template v-slot:[`item.eventReportTotal`]="{ item }">
          {{ formatCurrency(item.eventReportTotal) }}
        </template>
        <template v-slot:[`item.auctioneerName`]="{ item }">
          {{
            item.auctioneerName ? item.auctioneerName.toLowerCase().trim() : ""
          }}
        </template>

        <!-- expand & actions-->
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-0">
            <v-sheet flat dark tile color="grey darken-3 px-4 py-4">
              <div class="h-full flex flex-row flex-wrap">
                <!-- # winners & total -->
                <div class="grid gap-2 grow">
                  <div
                    class="flex items-center"
                    v-ripple
                    @click="
                      copyText(formatDate(item.dateCreated, 'MM/DD/YYYY'))
                    "
                  >
                    <v-icon xSmall color="pink" left>mdi-content-copy</v-icon>
                    Date Created:
                    {{ formatDate(item.dateCreated, "MM/DD/YYYY") }}
                  </div>
                  <!--  -->
                  <div
                    class="flex items-center"
                    v-ripple
                    @click="copyText(item.eventContactEmail)"
                  >
                    <v-icon xSmall color="pink" left>mdi-content-copy</v-icon>
                    Event Contact Email:
                    {{ item.eventContactEmail }}
                  </div>
                  <!--  -->
                  <div
                    class="flex items-center"
                    v-ripple
                    @click="copyText(item.numberOfWinners)"
                  >
                    <v-icon xSmall color="pink" left>mdi-content-copy</v-icon>
                    # Winners:
                    {{ item.numberOfWinners }}
                  </div>
                  <!--  -->
                  <div
                    class="flex flex-column"
                    v-ripple
                    @click="copyText(formatCurrency(item.eventReportTotal))"
                  >
                    <div>
                      <v-icon xSmall color="pink" left>mdi-content-copy</v-icon>
                      Total:
                      {{ formatCurrency(item.eventReportTotal) }}
                    </div>
                    <div class="caption mt-1">
                      {{
                        item.lessTenPercentDate
                          ? `Reduced 10% on ${formatDate(
                              item.lessTenPercentDate,
                              "MM/DD/YYYY"
                            )}`
                          : ``
                      }}
                      <br />
                      {{
                        item.lessTenPercentDate
                          ? `Original total ${formatCurrency(
                              item.preLessTenPercentTotal
                            )}`
                          : ""
                      }}
                    </div>
                  </div>
                </div>
                <!-- actions -->
                <div class="grid gap-2 grow">
                  <div
                    class="flex items-center"
                    v-ripple
                    @click="copyText(item.eventName)"
                  >
                    <v-icon xSmall color="pink" left>mdi-content-copy</v-icon>
                    Event Name:
                    {{ item.eventName }}
                  </div>
                  <!--  -->
                  <div
                    class="flex items-center"
                    v-ripple
                    @click="copyText(formatDate(item.eventDate, 'MM/DD/YYYY'))"
                  >
                    <v-icon xSmall color="pink" left>mdi-content-copy</v-icon>
                    Event Date:
                    {{ formatDate(item.eventDate, "MM/DD/YYYY") }}
                  </div>
                  <!--  -->
                  <div
                    class="flex items-center"
                    v-ripple
                    @click="copyText(item.eventReportNumber)"
                  >
                    <v-icon xSmall color="pink" left>mdi-content-copy</v-icon>
                    Invoice #:
                    {{ item.eventReportNumber }}
                  </div>
                  <!-- sent to accounting -->
                  <div
                    v-if="item.sendPaidToTennysonDate"
                    class="flex items-center"
                    v-ripple
                    @click="
                      copyText(
                        formatDate(item.sendPaidToTennysonDate, 'MM/DD/YYYY')
                      )
                    "
                  >
                    <v-icon xSmall color="pink" left>mdi-content-copy</v-icon>
                    Sent to Accounting on
                    {{ formatDate(item.sendPaidToTennysonDate, "MM/DD/YYYY") }}
                  </div>
                  <!--  -->
                  <div class="flex gap-2 mt-4">
                    <v-btn
                      small
                      color="primary"
                      depressed
                      :loading="loading"
                      :disabled="loading"
                      @click="onQuickActions(item)"
                      >Mark Paid</v-btn
                    >
                    <v-btn
                      small
                      color="primary"
                      depressed
                      :loading="loading"
                      :disabled="loading"
                      @click="onQuickActions(item)"
                      >Send Emails</v-btn
                    >
                    <v-btn
                      small
                      color="primary"
                      depressed
                      :loading="loading"
                      :disabled="loading"
                      @click="onEdit(item)"
                      >Open</v-btn
                    >
                    <!-- <v-btn
                      v-if="!item.qbSync"
                      small
                      color="primary"
                      depressed
                      :loading="loading"
                      :disabled="loading"
                      @click="quickBookSync(item.eventReportNumber)"
                      >QB Sync</v-btn
                    > -->
                  </div>
                </div>
                <!-- auctioneerInfo -->
                <div class="grid gap-2 grow" v-if="item.auctioneerUsed">
                  <div class="mb-n2">Auctioneer Info</div>
                  <div
                    class="flex items-center"
                    v-ripple
                    rounded
                    @click="copyText(item.auctioneerName)"
                  >
                    <v-icon xSmall color="pink" left>mdi-content-copy</v-icon>
                    Name: {{ item.auctioneerName }}
                  </div>
                  <div
                    class="flex items-center"
                    v-ripple
                    @click="copyText(item.auctioneerEmail)"
                  >
                    <v-icon xSmall color="pink" left>mdi-content-copy</v-icon>
                    Email: {{ item.auctioneerEmail }}
                  </div>
                  <div
                    class="flex items-center"
                    v-ripple
                    @click="copyText(item.auctioneerCompany)"
                  >
                    <v-icon xSmall color="pink" left>mdi-content-copy</v-icon>
                    Company: {{ item.auctioneerCompany }}
                  </div>
                </div>
              </div>
            </v-sheet>
          </td>
        </template>
      </v-data-table>
    </v-col>

    <!-- item/main Dialog -->
    <v-dialog
      v-model="itemDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      eager
    >
      <v-card tile id="top" :loading="loading">
        <v-toolbar
          dark
          color="primary"
          flat
          dense
          style="position: sticky; top: 0; left: 0; z-index: 999"
        >
          <v-btn
            icon
            dark
            :loading="loading"
            :disabled="loading"
            @click="dirty ? (dirtyDialog = true) : postTaskCleanUp()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ editing ? "Edit" : "New" }} Event Report
            {{ editing ? "# " + item.eventReportNumber : "" }}
          </v-toolbar-title>
          <v-spacer />
          <div v-if="editing">
            Date Submitted: {{ formatDate(item.dateCreated) }}
          </div>
          <v-spacer />
          <v-toolbar-items>
            <!-- <v-btn
              color="primary"
              v-if="editing && !item.qbSync"
              depressed
              style="margin-right: 10px"
              :loading="loading"
              :disabled="loading"
              @click="quickBookSync(item.eventReportNumber)"
              >QB Sync</v-btn
            > -->
            <v-btn
              color="error"
              text
              :loading="loading"
              :disabled="loading"
              @click="deleteDialog = true"
              class="mr-12"
            >
              Delete
            </v-btn>
            <v-btn
              dark
              text
              :loading="loading"
              :disabled="loading"
              @click="
                $refs.form.validate()
                  ? (preSaveActionsDialog = true)
                  : $toast.error('Please check form for errors')
              "
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text class="text--primary py-4">
          <!-- form -->
          <v-form ref="form">
            <!-- event information -->
            <v-row>
              <v-col cols="12"
                ><v-subheader class="body-1 font-weight-bold text--primary"
                  >Event Information</v-subheader
                ></v-col
              >
              <!-- reportCompletedBy -->
              <v-col cols="4">
                <v-radio-group
                  v-model.trim="item.reportCompletedBy"
                  dense
                  class="py-0 my-0"
                  :rules="[rules.req]"
                  :loading="loading"
                  :disabled="loading"
                  @change="
                    dirty = true;
                    (v) =>
                      !!v && v != 'other'
                        ? (item.reportCompletedByOtherName = '')
                        : '';
                  "
                >
                  <template v-slot:label>
                    <div class="mb-4 mt-n2 d-flex align-center">
                      <div class="mr-3">Report Completed By *</div>
                      <v-btn
                        class="mt-n1"
                        small
                        icon
                        color="primary"
                        @click="
                          $set(item, 'reportCompletedBy', 'other');
                          $set(
                            item,
                            'reportCompletedByOtherName',
                            'Ashley @ SAV'
                          );
                          dirty = true;
                        "
                        ><v-icon small>mdi-plus</v-icon></v-btn
                      >
                    </div>
                  </template>
                  <v-radio
                    v-for="(item, index) in [
                      'Organization',
                      'Auctioneer',
                      'Other',
                    ]"
                    :key="index"
                    :label="item"
                    :value="item.toLowerCase()"
                    @change="dirty = true"
                  ></v-radio>
                </v-radio-group>
                <v-expand-transition>
                  <v-text-field
                    @input="dirty = true"
                    v-if="item.reportCompletedBy == 'other'"
                    label="Report Completed By Name *"
                    v-model.trim="item.reportCompletedByOtherName"
                    :rules="[rules.req]"
                    :loading="loading"
                    :disabled="loading"
                  ></v-text-field>
                </v-expand-transition>
              </v-col>
              <v-col cols="8">
                <v-row>
                  <v-col>
                    <!-- organizationName -->
                    <v-text-field
                      :loading="loading"
                      :disabled="loading"
                      label="Organization Legal Name *"
                      v-model.trim="item.organizationName"
                      :rules="[rules.req]"
                      @input="dirty = true"
                    ></v-text-field>
                    <!-- eventName -->
                    <v-text-field
                      :loading="loading"
                      :disabled="loading"
                      label="Event Name *"
                      v-model.trim="item.eventName"
                      :rules="[rules.req]"
                      @input="dirty = true"
                    ></v-text-field>
                    <!-- eventContactLastName -->
                    <v-text-field
                      label="Event Contact Person Last Name *"
                      :loading="loading"
                      :disabled="loading"
                      v-model.trim="item.eventContactLastName"
                      :rules="[rules.req]"
                      @input="dirty = true"
                    ></v-text-field>
                    <!-- eventContactPhoneNumber -->
                    <v-text-field
                      :loading="loading"
                      :disabled="loading"
                      label="Event Contact Person Phone *"
                      v-model.trim="item.eventContactPhoneNumber"
                      persistent-hint
                      hint="Please enter numbers only. +1 is not necessary."
                      counter
                      maxlength="10"
                      @input="dirty = true"
                      :rules="[rules.req, rules.numOnly, rules.tenChars]"
                      append-icon="mdi-plus"
                      @click:append="
                        $set(item, 'eventContactPhoneNumber', '4074751175');
                        dirty = true;
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <!-- organizationAddress -->
                    <v-text-field
                      :loading="loading"
                      :disabled="loading"
                      label="Organization Billing Address"
                      v-model.trim="item.organizationAddress"
                      @input="dirty = true"
                    ></v-text-field>
                    <!-- eventDate -->
                    <v-text-field
                      :loading="loading"
                      :disabled="loading"
                      :value="formatDate(item.eventDate)"
                      label="Event Date *"
                      readonly
                      :rules="[rules.req]"
                      @click="eventDateDialog = true"
                      @input="dirty = true"
                    ></v-text-field>
                    <!-- eventContactFirstName -->
                    <v-text-field
                      label="Event Contact Person First Name *"
                      :loading="loading"
                      :disabled="loading"
                      v-model.trim="item.eventContactFirstName"
                      :rules="[rules.req]"
                      @input="dirty = true"
                    ></v-text-field>
                    <!-- eventContactEmail -->
                    <v-text-field
                      :loading="loading"
                      :disabled="loading"
                      v-model.trim="item.eventContactEmail"
                      @input="dirty = true"
                      @blur="
                        (e) =>
                          !!e.target.value
                            ? (item.eventContactEmail = item.eventContactEmail.toLowerCase())
                            : ''
                      "
                      label="Event Contact Person Email *"
                      type="email"
                      persistent-hint
                      hint="Important: Winner redemption emails will automatically be sent to this email address once your invoice has been paid. Please ensure you enter a working email that you have access receive communications to."
                      :rules="[rules.req, rules.email]"
                      append-icon="mdi-plus"
                      @click:append="
                        $set(
                          item,
                          'eventContactEmail',
                          'booking@silentauctionvacations.com'
                        );
                        dirty = true;
                      "
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-divider />
              </v-col>
            </v-row>

            <!-- team member information -->
            <v-row>
              <v-col cols="12"
                ><v-subheader class="body-1 font-weight-bold text--primary"
                  >Team Member Information</v-subheader
                ></v-col
              >

              <!-- useAuctioneer -->
              <v-col cols="4">
                <v-radio-group
                  v-model.trim="item.auctioneerUsed"
                  :loading="loading"
                  :disabled="loading"
                  dense
                  class="py-0 my-0"
                  :rules="[rules.req]"
                  @change="
                    (v) =>
                      !v
                        ? ((item.auctioneerName = ''),
                          (item.auctioneerEmail = ''),
                          (item.auctioneerCompany = ''),
                          (item.sendToAuctioneerEmail = false))
                        : ''
                  "
                >
                  <template v-slot:label>
                    <div class="mb-4 mt-n2">
                      Did you use an auctioneer or other event professional that
                      specifically recommended Charity Getaways? *
                    </div>
                  </template>
                  <v-radio
                    v-for="(item, index) in [
                      { text: 'Yes', value: true },
                      { text: 'No', value: false },
                    ]"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                    @change="dirty = true"
                  ></v-radio>
                </v-radio-group>
                <v-expand-transition>
                  <v-text-field
                    :loading="loading"
                    :disabled="loading"
                    v-if="item.auctioneerUsed"
                    label="Auctioneer/Event Professional Name *"
                    v-model.trim="item.auctioneerName"
                    :rules="[rules.req]"
                    @input="dirty = true"
                  ></v-text-field>
                </v-expand-transition>
                <v-expand-transition>
                  <v-text-field
                    :loading="loading"
                    :disabled="loading"
                    v-if="item.auctioneerUsed"
                    label="Auctioneer/Event Professional Company"
                    v-model.trim="item.auctioneerCompany"
                    @input="dirty = true"
                  ></v-text-field>
                </v-expand-transition>
                <v-expand-transition>
                  <v-text-field
                    :loading="loading"
                    :disabled="loading"
                    v-if="item.auctioneerUsed"
                    v-model.trim="item.auctioneerEmail"
                    label="Auctioneer/Event Professional Email *"
                    type="email"
                    :rules="[rules.req, rules.email]"
                    @input="dirty = true"
                    @blur="
                      (e) =>
                        !!e.target.value
                          ? (item.auctioneerEmail = item.auctioneerEmail.toLowerCase())
                          : ''
                    "
                  ></v-text-field>
                </v-expand-transition>
              </v-col>

              <!-- useSavTeamMember -->
              <v-col cols="4">
                <v-radio-group
                  :loading="loading"
                  :disabled="loading"
                  v-model.trim="item.savSalesUsed"
                  dense
                  class="py-0 my-0"
                  :rules="[rules.req]"
                  @change="
                    (v) =>
                      !v
                        ? ((item.savSalesName = ''),
                          (item.savSalesOtherName = ''))
                        : ''
                  "
                >
                  <template v-slot:label>
                    <div class="mb-4 mt-n2 d-flex align-center">
                      <div>
                        Did a member of the Charity Getaways sales team
                        assist you with this event? *
                      </div>
                      <v-btn
                        small
                        icon
                        color="primary"
                        @click="
                          $set(item, 'savSalesUsed', true);
                          $set(item, 'savSalesName', 'April McGill');
                          dirty = true;
                        "
                        ><v-icon small>mdi-plus</v-icon></v-btn
                      >
                    </div>
                  </template>
                  <v-radio
                    v-for="(item, index) in [
                      { text: 'Yes', value: true },
                      { text: 'No', value: false },
                    ]"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                    @change="dirty = true"
                  ></v-radio>
                </v-radio-group>
                <v-expand-transition>
                  <v-select
                    :loading="loading"
                    :disabled="loading"
                    dense
                    v-if="item.savSalesUsed"
                    :items="['April McGill', 'Jeannie Retherford', 'Other']"
                    v-model="item.savSalesName"
                    label="SAV Sales Team Member Name *"
                    :rules="[rules.req]"
                    @change="dirty = true"
                  ></v-select>
                </v-expand-transition>

                <v-expand-transition>
                  <v-text-field
                    :loading="loading"
                    :disabled="loading"
                    v-if="item.savSalesUsed && item.savSalesName == 'Other'"
                    label="SAV Sales Team Member Name *"
                    v-model.trim="item.savSalesOtherName"
                    :rules="[rules.req]"
                    @input="dirty = true"
                  ></v-text-field>
                </v-expand-transition>
              </v-col>

              <v-col cols="12">
                <v-divider />
              </v-col>
            </v-row>

            <!-- winner information -->
            <v-row>
              <v-col cols="12"
                ><v-subheader class="body-1 font-weight-bold text--primary"
                  >Winner Information</v-subheader
                ></v-col
              >
              <v-col
                cols="12"
                v-for="(i, index) in item.winners"
                :key="index"
                :id="`winner-${index}`"
              >
                <v-card
                  outlined
                  :loading="loading"
                  :class="{ 'grey lighten-2': !$vuetify.theme.dark }"
                >
                  <v-card-text class="px-4 py-1 pb-4">
                    <v-row>
                      <!-- header -->
                      <v-col cols="12" class="d-flex">
                        <v-subheader
                          class="text--primary pl-0 font-weight-medium"
                          >Winner {{ index + 1 }} Information</v-subheader
                        >
                        <v-spacer />
                        <!-- reg info -->
                        <v-alert
                          dense
                          type="success"
                          :icon="false"
                          outlined
                          class="mt-2"
                          v-if="
                            userAccounts.some(
                              (acc) => acc.packageID == i.packageID
                            )
                          "
                        >
                          <span
                            >Registered on
                            <strong>{{
                              formatDate(
                                userAccounts.filter(
                                  (acc) => acc.packageID == i.packageID
                                )[0].dateRegistered
                              )
                            }}</strong>
                            with email address
                            <strong>{{
                              userAccounts.filter(
                                (acc) => acc.packageID == i.packageID
                              )[0].email
                            }}</strong></span
                          >
                          <v-btn
                            :loading="loading"
                            :disabled="loading"
                            small
                            text
                            color="primary"
                            class="ml-6"
                            :to="
                              `users/${
                                userAccounts.filter(
                                  (acc) => acc.packageID == i.packageID
                                )[0].id
                              }`
                            "
                            >View User Record</v-btn
                          >
                        </v-alert>
                        <v-spacer />
                        <div class="mt-1">
                          <v-btn
                            :loading="loading"
                            :disabled="loading"
                            icon
                            color="error"
                            v-if="index > 0"
                            @click="
                              dirty = true;
                              item.winners.splice(index, 1);
                              $toast.success('Winner Removed', {
                                timeout: 2000,
                              });
                              justAddedWinnerAlert = false;
                            "
                          >
                            <v-icon>mdi-minus-circle-outline</v-icon>
                          </v-btn>
                          <v-btn
                            :loading="loading"
                            :disabled="loading"
                            icon
                            color="primary"
                            @click="
                              scrollToLastWinner();
                              dirty = true;
                              item.winners.push({
                                costToOrg: '',
                                destination: '',
                                isRegistered: false,
                                lastName: '',
                                numberNights: '',
                                packageCode: '',
                                packageID: '',
                                unitType: '',
                                travelByDate: '',
                              });
                              $toast.success('Winner Added', {
                                timeout: 2000,
                              });
                              justAddedWinnerAlert = true;
                            "
                          >
                            <v-icon>mdi-plus-circle-outline</v-icon>
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="3">
                        <!-- lastName -->
                        <v-text-field
                          :loading="loading"
                          :disabled="loading"
                          label="Last Name *"
                          v-model.trim="i.lastName"
                          :rules="[rules.req]"
                          @input="dirty = true"
                        ></v-text-field>
                        <!-- packageCode -->
                        <v-autocomplete
                          class="mt-6"
                          :loading="loading"
                          :disabled="loading"
                          dense
                          @change="
                            setWinnerInfo(index, $event);
                            dirty = true;
                          "
                          :items="retailPackages"
                          item-text="packageCode"
                          return-object
                          v-model.trim="i.packageCode"
                          label="Package Code *"
                          :rules="[rules.req]"
                          hint="Select or type in package code"
                          persistent-hint
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="3" class="pl-5">
                        <!-- destination -->
                        <v-text-field
                          v-if="i.packageCode"
                          readonly
                          @click="dirty = true"
                          label="Destination *"
                          :loading="loading"
                          :disabled="loading"
                          v-model="i.destination"
                          :rules="[rules.req]"
                        ></v-text-field>
                        <!-- unitType -->
                        <v-text-field
                          v-if="i.packageCode"
                          readonly
                          @click="dirty = true"
                          label="Unit Type *"
                          :loading="loading"
                          :disabled="loading"
                          v-model="i.unitType"
                          :rules="[rules.req]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <!-- costToOrg -->
                        <v-text-field
                          v-if="i.packageCode"
                          @click="dirty = true"
                          label="Cost to Organization *"
                          :loading="loading"
                          :disabled="loading"
                          v-model="i.costToOrg"
                          :rules="[rules.req, rules.numOnly]"
                          persistent-hint
                          :hint="i.costToOrg ? formatCurrency(i.costToOrg) : ''"
                        ></v-text-field>

                        <!-- numberNights -->
                        <v-text-field
                          v-if="i.packageCode"
                          @click="dirty = true"
                          readonly
                          label="Number of Nights *"
                          :loading="loading"
                          :disabled="loading"
                          v-model="i.numberNights"
                          :rules="[rules.req, rules.numOnly]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <!-- packageID -->
                        <v-text-field
                          @click="dirty = true"
                          label="Package ID *"
                          :loading="loading"
                          :disabled="loading"
                          readonly
                          :value="i.packageID"
                          :rules="[rules.req]"
                        ></v-text-field>
                        <!-- travelByDate -->
                        <v-text-field
                          @click="dirty = true"
                          label="Travel By Date *"
                          :loading="loading"
                          :disabled="loading"
                          v-model="i.travelByDate"
                          :rules="[rules.req]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <!-- send congrats email -->
                    <v-btn
                      v-if="
                        item.eventContactEmail &&
                          editing &&
                          i.lastName &&
                          i.packageCode &&
                          i.destination &&
                          i.costToOrg &&
                          i.unitType &&
                          i.numberNights &&
                          i.packageID &&
                          i.travelByDate
                      "
                      icon
                      style="position: absolute; right: 12px; bottom: 0px"
                      @click="
                        congratsEmailDialog = true;
                        congratsEmailDialogWinner = i;
                      "
                      :loading="loading"
                      :disabled="loading"
                    >
                      <v-icon>mdi-email-send-outline</v-icon>
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" id="scrollSection">
                <v-divider />
              </v-col>
            </v-row>

            <!-- justAddedWinnerAlert -->
            <v-row v-show="justAddedWinnerAlert">
              <v-col cols="12">
                <v-alert
                  type="info"
                  border="left"
                  dismissible
                  v-model="justAddedWinnerAlert"
                  >Add new winner information in the section titled
                  <strong>Winner Information</strong>. You may enter as many
                  winners as you need to a single invoice.
                </v-alert>
              </v-col>
            </v-row>

            <!-- invoice information -->
            <v-row>
              <v-col cols="12">
                <v-subheader class="body-1 font-weight-bold text--primary"
                  >Invoice Information</v-subheader
                ></v-col
              >

              <v-col cols="4">
                <!-- numberOfWinners -->
                <div>
                  <span class="body-2 d-block">Number of Winners</span>
                  <span
                    class="caption d-block text--secondary"
                    v-if="item.winners && item.winners.length"
                  >
                    {{ item.winners.length }}
                  </span>
                </div>
                <!-- invoice total -->
                <div class="mt-5">
                  <v-text-field
                    :append-icon="item.lessTenPercentDate ? '' : 'mdi-percent'"
                    @click="dirty = true"
                    label="Event Report Total *"
                    :loading="loading"
                    :disabled="loading"
                    v-model="item.eventReportTotal"
                    :rules="[rules.req, rules.numOnly]"
                    persistent-hint
                    :hint="
                      item.eventReportTotal
                        ? `${
                            item.lessTenPercentDate
                              ? `Original total of ${formatCurrency(
                                  item.preLessTenPercentTotal
                                )} reduced 10% on ${formatDate(
                                  item.lessTenPercentDate,
                                  'MM/DD/YYYY'
                                )} to `
                              : ''
                          }${formatCurrency(item.eventReportTotal)}`
                        : ''
                    "
                    @click:append="calcNewTotalDialog = true"
                  ></v-text-field>
                </div>
                <!-- isPaid -->
                <div>
                  <v-switch
                    :loading="loading"
                    :disabled="loading"
                    dense
                    inset
                    v-model="item.isPaid"
                    label="Event Report Paid?"
                    @click="dirty = true"
                    @change="
                      (v) =>
                        !v
                          ? ((datePaidDialog = false), (item.datePaid = ''))
                          : (datePaidDialog = true)
                    "
                  ></v-switch>
                  <!-- date paid -->
                  <v-text-field
                    @click="datePaidDialog = true"
                    class="mt-4"
                    dense
                    readonly
                    label="Date Paid"
                    :loading="loading"
                    v-if="item.isPaid && item.datePaid != ''"
                    :value="formatDate(item.datePaid)"
                  ></v-text-field>
                </div>
              </v-col>
              <!-- send to additional email -->
              <v-col cols="4">
                <v-subheader class="body-2 px-0 pb-2 mt-n2"
                  >Email a copy of this invoice to an additional email address?
                  *</v-subheader
                >
                <v-radio-group
                  :loading="loading"
                  :disabled="loading"
                  v-model.trim="item.sendToAdditionalEmail"
                  dense
                  class="py-0 my-0"
                  :rules="[rules.req]"
                  @change="(v) => (!v ? (item.additionalEmail = '') : '')"
                >
                  <v-radio
                    v-for="(item, index) in [
                      { text: 'Yes', value: true },
                      { text: 'No', value: false },
                    ]"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                    @change="dirty = true"
                  ></v-radio>
                </v-radio-group>
                <v-expand-transition>
                  <v-text-field
                    :loading="loading"
                    :disabled="loading"
                    v-if="item.sendToAdditionalEmail"
                    @input="dirty = true"
                    v-model.trim="item.additionalEmail"
                    type="email"
                    persistent-hint
                    hint="This email will receive a copy of this invoice"
                    label="Additional Email *"
                    :rules="[rules.req, rules.email]"
                    @blur="
                      (e) =>
                        !!e.target.value
                          ? (item.additionalEmail = item.additionalEmail.toLowerCase())
                          : ''
                    "
                  ></v-text-field>
                </v-expand-transition>
                <span
                  class="d-block caption mt-5"
                  v-if="item.sendToAdditionalEmail && item.additionalEmail"
                  ><strong>{{
                    item.additionalEmail ? item.additionalEmail : ""
                  }}</strong>
                  will also be notified of this submission</span
                >
              </v-col>
              <!-- send to auctioneer -->
              <v-col v-if="item.auctioneerUsed">
                <v-subheader class="body-2 px-0 pb-2 mt-n2"
                  >Email a copy of this invoice to your auctioneer?
                  *</v-subheader
                >
                <v-radio-group
                  :loading="loading"
                  :disabled="loading"
                  v-if="item.auctioneerUsed"
                  v-model.trim="item.sendToAuctioneerEmail"
                  dense
                  class="py-0 my-0"
                  :rules="[rules.req]"
                  @change="dirty = true"
                >
                  <v-radio
                    v-for="(item, index) in [
                      { text: 'Yes', value: true },
                      { text: 'No', value: false },
                    ]"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                    required
                    @change="dirty = true"
                  ></v-radio>
                </v-radio-group>
                <span
                  class="d-block caption"
                  v-if="
                    item.auctioneerUsed &&
                      item.sendToAuctioneerEmail &&
                      item.auctioneerEmail
                  "
                  ><strong>{{
                    item.auctioneerEmail ? item.auctioneerEmail : ""
                  }}</strong>
                  will also be notified of this submission</span
                >
              </v-col>

              <v-col cols="12">
                <v-divider />
              </v-col>
            </v-row>

            <!-- admin information -->
            <v-row>
              <v-col cols="12">
                <v-subheader class="body-1 font-weight-bold text--primary"
                  >Admin Information</v-subheader
                ></v-col
              >
              <!-- adminNotes -->
              <v-col cols="8">
                <v-textarea
                  @input="dirty = true"
                  v-model="item.adminNotes"
                  label="Admin Notes (not visible to travelers)"
                  persistent-hint
                  hint="Content does NOT need to be wrapped in <p></p>"
                  rows="4"
                  outlined
                ></v-textarea>
              </v-col>

              <!-- dates -->
              <v-col cols="4">
                <v-row dense>
                  <v-col cols="12" v-if="editing">
                    <span class="font-weight-bold">Date Submitted:</span>
                    {{ formatDate(item.dateCreated) }}
                  </v-col>
                  <v-col cols="12" v-if="item.dateUpdated">
                    <span class="font-weight-bold">Date Last Edited:</span>
                    {{ formatDate(item.dateUpdated) }}</v-col
                  >
                  <v-col cols="12" v-if="item.travelByDate">
                    <span class="font-weight-bold"
                      >Invoice Travel By Date:</span
                    >
                    {{ formatDate(item.travelByDate) }}</v-col
                  >
                  <v-col cols="12" v-if="item.id">
                    <span class="font-weight-bold">Event Report ID:</span>
                    {{ item.id }}</v-col
                  >
                  <v-col cols="12" v-if="item.eventReportNumber">
                    <span class="font-weight-bold">Event Report Number:</span>
                    {{ item.eventReportNumber }}</v-col
                  >
                  <v-col cols="12" v-if="item.refWebsite">
                    <span class="font-weight-bold">Referring Website:</span>
                    {{ item.refWebsite }}</v-col
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider />
      </v-card>
    </v-dialog>

    <!-- deleteDialog -->
    <v-dialog v-model="deleteDialog" width="500px">
      <v-card :loading="loading">
        <v-card-title class="text-h5 d-flex">
          <v-icon color="error" class="mr-3">mdi-alert-outline</v-icon>
          <span>Delete This Event Report?</span>
          <v-spacer />
          <span>
            <v-btn
              icon
              class="mt-n3 mr-n2"
              @click="deleteDialog = false"
              :loading="loading"
              :disabled="loading"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </span>
        </v-card-title>

        <v-card-text class="text--primary body-1 mt-2">
          <p>Are you sure you want to delete this event report?</p>
          <p>
            Any travelers registered from this event report will lose access to
            the traveler portal.
          </p>
          <p>
            The data will be permanently lost. These changes cannot be reversed.
          </p>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="deleteDialog = false"
            :loading="loading"
            :disabled="loading"
          >
            No, cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="error"
            depressed
            @click="handleDelete"
            :loading="loading"
            :disabled="loading"
          >
            Yes, delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dirtyDialog -->
    <v-dialog v-model="dirtyDialog" width="500px">
      <v-card :loading="loading">
        <v-card-title class="text-h5 d-flex">
          <span> Save Changes?</span>
          <v-spacer />
          <span>
            <v-btn
              icon
              class="mt-n3 mr-n2"
              @click="postTaskCleanUp()"
              :loading="loading"
              :disabled="loading"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </span>
        </v-card-title>

        <v-card-text class="text--primary body-1 mt-2">
          There have been changes to this item. Would you like to save them?
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="postTaskCleanUp()"
            :loading="loading"
            :disabled="loading"
          >
            No, discard changes
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            depressed
            @click="
              dirtyDialog = false;
              $refs.form.validate()
                ? (preSaveActionsDialog = true)
                : $toast.error('Please check form for errors');
            "
            :loading="loading"
            :disabled="loading"
          >
            Yes, save changes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- eventDateDialog -->
    <v-dialog v-model="eventDateDialog" width="290px">
      <v-card :loading="loading">
        <v-date-picker
          @change="
            eventDateDialog = false;
            dirty = true;
          "
          v-model.trim="item.eventDate"
          scrollable
        >
        </v-date-picker>
      </v-card>
    </v-dialog>

    <!-- datePaidDialog -->
    <v-dialog v-model="datePaidDialog" width="290px">
      <v-card :loading="loading">
        <v-date-picker
          @change="
            dirty = true;
            datePaidDialog = false;
          "
          v-model.trim="item.datePaid"
          scrollable
        >
        </v-date-picker>
      </v-card>
    </v-dialog>

    <!-- preSave/quickActions Dialog -->
    <v-dialog v-model="preSaveActionsDialog" width="500px">
      <v-card :loading="loading">
        <v-card-title class="text-h5 d-flex">
          <span>Select Actions</span>
          <v-spacer />
          <span>
            <v-btn
              icon
              class="mt-n3 mr-n2"
              @click="postTaskCleanUp()"
              :loading="loading"
              :disabled="loading"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </span>
        </v-card-title>

        <v-card-text class="text--primary body-1 mt-2">
          <v-row>
            <v-col cols="12" class="pb-0 mb-0">
              <h3 class="mb-4">
                Please select what actions you'd like to take when saving this
                event report
              </h3></v-col
            >

            <v-col cols="12" class="mt-4">
              <v-alert border="top" type="info" :icon="false" class="mb-1">
                <span class="d-block">Event Name: {{ item.eventName }}</span>
                <span class="d-block">
                  Event Report #: {{ item.eventReportNumber }}</span
                >
              </v-alert>
            </v-col>

            <v-col cols="12">
              <v-switch
                :loading="loading"
                :disabled="loading"
                label="archive"
                inset
                persistent-hint
                hint="a safe alternative to delete"
                class="font-weight-bold"
                v-model="item.archived"
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-switch
                :loading="loading"
                :disabled="loading"
                label="send original event report email (invoice)"
                inset
                persistent-hint
                class="font-weight-bold"
                :hint="
                  `send an invoice email to ${item.eventContactEmail}${
                    item.sendToAuctioneerEmail && item.auctioneerEmail
                      ? ', ' + item.auctioneerEmail
                      : ''
                  }${
                    item.sendToAdditionalEmail && item.additionalEmail
                      ? ', ' + item.additionalEmail
                      : ''
                  }`
                "
                v-model="sendOriginalEmail"
              ></v-switch
            ></v-col>
            <v-col cols="12">
              <v-switch
                :loading="loading"
                :disabled="loading"
                label="send explainer email"
                inset
                persistent-hint
                class="font-weight-bold"
                :hint="`send an explainer email to ${item.eventContactEmail}`"
                v-model="sendExplainerEmail"
              ></v-switch
            ></v-col>
            <v-col cols="12">
              <v-switch
                :loading="loading"
                :disabled="loading"
                label="send winner congrats emails"
                inset
                persistent-hint
                class="font-weight-bold"
                :hint="`send congrats emails to ${item.eventContactEmail}`"
                v-model="sendCongratsEmails"
              ></v-switch
            ></v-col>
            <v-col cols="12">
              <v-switch
                :loading="loading"
                :disabled="loading"
                label="mark event report as paid"
                inset
                persistent-hint
                :hint="
                  `${
                    item.isPaid && item.datePaid
                      ? 'date paid ' + formatDate(item.datePaid)
                      : 'currently marked as unpaid'
                  }`
                "
                class="font-weight-bold"
                v-model="item.isPaid"
                @click="dirty = true"
                @change="
                  (v) =>
                    !v
                      ? ((datePaidDialog = false), (item.datePaid = ''))
                      : (datePaidDialog = true)
                "
              ></v-switch>
            </v-col>

            <!-- Send as paid to Accounting -->
            <v-col cols="12">
              <v-switch
                v-if="item.isPaid"
                :loading="loading"
                :disabled="loading"
                label="send as paid to accounting"
                inset
                class="font-weight-bold"
                v-model="tennysonEmail"
                @click="dirty = true"
                @change="
                  (v) =>
                    !v
                      ? ''
                      : (item.sendPaidToTennysonDate = new Date()
                          .toISOString()
                          .substring(0, 10))
                "
                :hint="
                  `${
                    item.sendPaidToTennysonDate
                      ? `last sent to accounting@charitygetaways.com on ${formatDate(
                          item.sendPaidToTennysonDate,
                          'MM/DD/YYYY'
                        )}`
                      : `not sent to accounting@charitygetaways.com`
                  }`
                "
                persistent-hint
              ></v-switch>
            </v-col>

            <v-col cols="12" v-if="item.archived" class="mt-4">
              <v-alert type="info" :icon="false" border="left"
                >Archiving this event report will keep the record in the
                database, but remove it from the admin portal</v-alert
              ></v-col
            >
            <v-col
              cols="12"
              v-if="
                (!item.isPaid && sendCongratsEmails) ||
                  (!item.isPaid && sendExplainerEmail)
              "
            >
              <v-alert type="warning" :icon="false" border="left"
                ><strong>Warning:</strong> This event report has not been paid.
                Sending congrats emails is not recommended and will give
                travelers access to the traveler portal before their event
                report has been paid.</v-alert
              ></v-col
            >
          </v-row>
        </v-card-text>

        <v-card-actions class="mt-4">
          <v-btn
            color="primary"
            text
            @click="postTaskCleanUp()"
            :loading="loading"
            :disabled="loading"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            depressed
            @click="itemDialog ? submit() : submitQuickActions()"
            :loading="loading"
            :disabled="loading"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- congratsEmailDialog -->
    <v-dialog v-model="congratsEmailDialog" width="500px">
      <v-card :loading="loading">
        <v-card-title class="text-h5 d-flex">
          <span> Send Congrats Email?</span>
          <v-spacer />
          <span>
            <v-btn
              icon
              class="mt-n3 mr-n2"
              @click="congratsEmailDialog = false"
              :loading="loading"
              :disabled="loading"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </span>
        </v-card-title>

        <v-card-text class="text--primary body-1 mt-2">
          <p>
            Send a congrats email to
            <strong>{{ item.eventContactEmail }}</strong
            >?
          </p>

          <p><strong>Winner Information:</strong></p>

          <ul>
            <li>Last Name: {{ congratsEmailDialogWinner.lastName }}</li>
            <li>Package Code: {{ congratsEmailDialogWinner.packageCode }}</li>
            <li>Destination: {{ congratsEmailDialogWinner.destination }}</li>
            <li>Unit Type: {{ congratsEmailDialogWinner.unitType }}</li>
            <li>Cost to Org: {{ congratsEmailDialogWinner.costToOrg }}</li>
            <li>
              Number of Nights: {{ congratsEmailDialogWinner.numberNights }}
            </li>
            <li>PUID: {{ congratsEmailDialogWinner.packageID }}</li>
            <li>
              Travel By Date: {{ congratsEmailDialogWinner.travelByDate }}
            </li>
          </ul>

          <v-alert
            class="mt-8"
            type="warning"
            :icon="false"
            border="left"
            v-if="!item.isPaid"
            ><strong>Warning:</strong> This event report has not been paid.
            Sending congrats emails is not recommended and will give travelers
            access to the traveler portal before their event report has been
            paid.</v-alert
          >
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="congratsEmailDialog = false"
            :loading="loading"
            :disabled="loading"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            depressed
            @click="
              sendCongratsEmails = true;
              onSendCongratsEmail(congratsEmailDialogWinner);
            "
            :loading="loading"
            :disabled="loading"
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- calcNewTotalDialog (less 10%) -->
    <v-dialog v-model="calcNewTotalDialog" width="500px">
      <v-card :loading="loading">
        <v-card-title class="text-h5 d-flex">
          <span>Adjust Total?</span>
          <v-spacer />
          <span>
            <v-btn
              icon
              class="mt-n3 mr-n2"
              @click="calcNewTotalDialog = false"
              :loading="loading"
              :disabled="loading"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </span>
        </v-card-title>

        <v-card-text class="text--primary body-1 mt-2">
          <p>Would you like to set the invoice total to 10% less?</p>
          <p>Current Total: {{ formatCurrency(item.eventReportTotal) }}</p>
          <p class="font-weight-bold">
            New Total (Less 10%):
            {{ formatCurrency(item.eventReportTotal * ((100 - 10) / 100)) }}
          </p>
          <p class="body-2">
            Please note: the invoice total will recalculate and be overwritten
            if winners are added/removed
          </p>
        </v-card-text>

        <v-card-actions class="d-block">
          <div class="flex items-center">
            <v-btn
              color="primary"
              text
              @click="calcNewTotalDialog = false"
              :loading="loading"
              :disabled="loading"
            >
              Cancel
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              depressed
              @click="
                dirty = true;
                item.preLessTenPercentTotal = item.eventReportTotal;
                item.lessTenPercentDate = new Date()
                  .toISOString()
                  .substring(0, 10);
                item.eventReportTotal =
                  item.eventReportTotal * ((100 - 10) / 100);
                submit();
              "
              :loading="loading"
              :disabled="loading"
            >
              Save invoice with new total
            </v-btn>
          </div>
          <v-divider class="mt-5 mb-3" />
          <div class="caption text-right">
            Clicking the save button will save all changes and close this
            window.
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { portalsApp } from "@/firebase";
import formatDate from "@/mixins/formatDate";
import formatCurrency from "@/mixins/formatCurrency";
import copyText from "@/mixins/copyText";
import formRules from "@/mixins/formRules";
import NProgress from "nprogress";
import moment from "moment";
import axios from "axios";
import Handlebars from "handlebars";

Handlebars.registerHelper("truncate", (str, length) => {
  return str.length > length ? str.substr(0, length - 1) + " ..." : str;
});

Handlebars.registerHelper("currency", (number) => {
  let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  return formatter.format(number);
});

Handlebars.registerHelper("date", (dateISO) => {
  return moment(dateISO).format("MM/DD/YYYY");
});

Handlebars.registerHelper("phone", (phoneNumberString) => {
  let cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) return "(" + match[1] + ") " + match[2] + "-" + match[3];
  return phoneNumberString;
});

export default {
  mixins: [formatDate, formatCurrency, copyText, formRules],
  firestore: {
    retailPackages: portalsApp
      .firestore()
      .collection("retailPackages")
      .orderBy("packageCode"),
    userAccounts: portalsApp.firestore().collection("userAccounts"),
  },
  data: () => ({
    isValidQBConnection: false,
    deleteDialog: false,
    tennysonEmail: false,
    congratsEmailDialogWinner: {},
    congratsEmailDialog: false,
    sendExplainerEmail: false,
    sendOriginalEmail: false,
    sendCongratsEmails: false,
    preSaveActionsDialog: false,
    calcNewTotalDialog: false,
    datePaidDialog: false,
    userAccounts: [],
    justAddedWinnerAlert: false,
    retailPackages: [],
    expanded: [],
    loading: true,
    itemsPerPage: 15,
    search: "",
    searching: false,
    itemDialog: false,
    editing: false,
    item: {},
    dirty: false,
    dirtyDialog: false,
    eventDateDialog: false,
    headers: [
      {
        text: "Org. Name",
        value: "organizationName",
      },
      {
        text: "Event Name",
        value: "eventName",
      },
      {
        text: "Event Date",
        value: "eventDate",
      },
      {
        text: "Paid",
        value: "isPaid",
      },
      {
        text: "QB Sync",
        value: "qbSync",
      },
      {
        text: "#",
        value: "eventReportNumber",
      },
      {
        text: "Total",
        value: "eventReportTotal",
      },
      {
        text: "Auctioneer",
        value: "auctioneerName",
      },
      { text: "", value: "data-table-expand" },
    ],
  }),
  computed: {
    items() {
      if (!this.$store.state.eventReports) return;
      return this.$store.state.eventReports.filter((i) => !i.archived);
    },
  },
  mounted() {
    // this.isValidQBToken();
    // this.chechRedirectFromQB();
  },
  methods: {
    // chechRedirectFromQB() {
    //   if (this.$route.query.hasOwnProperty("success")) {
    //     this.$toast.success("QuickBook Connected Successfully.");
    //   }
    // },
    // isValidQBToken() {
    //   axios
    //     .get("https://api.silentauctionvacations.com/checkTokenStatus")
    //     .then((res) => {
    //       // console.log(res);
    //       this.isValidQBConnection = res.data.isValid;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    // quickBookConnect() {
    //   this.loading = true;
    //   axios
    //     .get("https://api.silentauctionvacations.com/connectQb")
    //     .then((res) => {
    //       this.loading = false;
    //       // console.log(res);
    //       window.location.href = res.data.authUri;
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //       console.log(err);
    //     });
    // },
    // async quickBookDelete(id) {
    //   this.loading = true;
    //   await axios
    //     .delete(`https://api.silentauctionvacations.com/deleteInvoice/${id}`)
    //     .then((res) => {
    //       this.loading = false;
    //       // console.log(res);
    //       // this.$toast.success(res.data.message);
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //       console.log(err);
    //       // this.$toast.error(err.response.data.message);
    //     });
    // },
    // async quickBookSync(id) {
    //   this.loading = true;
    //   await axios
    //     .get(`https://api.silentauctionvacations.com/eventReport/${id}`)
    //     .then((res) => {
    //       this.loading = false;
    //       // console.log(res);
    //       // this.$toast.success(res.data.message);
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //       console.log(err);
    //       this.$toast.error(err.response.data.message);
    //     });
    // },
    // async quickBookUpdateSync(id) {
    //   this.loading = true;
    //   await axios
    //     .put(`https://api.silentauctionvacations.com/updateInvoiceStatus`, {
    //       eventReportNumber: id,
    //     })
    //     .then((res) => {
    //       this.$toast.success(res.data.message);
    //       this.loading = false;
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //       console.log(err);
    //       this.$toast.error(err.response.data.message);
    //     });
    // },
    async handleDelete() {
      if (!this.item.id) return;
      // console.log("deleting", this.item.id);
      this.loading = true;
      // this.$toast.success("Event Report Deleted");

      await portalsApp
        .firestore()
        .collection("eventReports")
        .doc(this.item.id)
        .delete();

      this.postTaskCleanUp();
      this.expanded = [];
    },
    postTaskCleanUp() {
      this.preSaveActionsDialog = false;
      this.calcNewTotalDialog = false;
      this.editing = false;
      this.item = {};
      this.itemDialog = false;
      this.dirtyDialog = false;
      this.congratsEmailDialog = false;
      this.dirty = false;
      this.sendOriginalEmail = false;
      this.sendExplainerEmail = false;
      this.sendCongratsEmails = false;
      this.justAddedWinnerAlert = false;
      this.tennysonEmail = false;
      this.deleteDialog = false;
      this.loading = false;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    async onSendExplainerEmail() {
      if (
        !Object.values(this.item).length ||
        !this.item.winners.length ||
        !this.sendExplainerEmail
      )
        return this.$toast.error("Error: onSendExplainerEmail()");

      return new Promise(async (resolve, reject) => {
        // data for html template and nodemailer
        // Removed developer email
        let emailData = {
          subject: `Thank you for your payment (Charity Getaways) ${this.item.eventName}`,
          to: [
            process.env.NODE_ENV.trim() == "development"
              ? ""
              : this.item.eventContactEmail,
          ],
          html: "",
        };

        // email template
        let template = `
        <div style="font-family: 'Roboto', sans-serif;max-width: 768px;">
        <p>
        <small><i>
        This is an automatically generated email from an unattended email inbox. <strong>Please do not reply directly to this email.</strong>
        </i></small>
        </p>
        <p>Hello {{eventContactFirstName}} {{eventContactLastName}},</p>
        <p>SAV has received your payment, thank you.</p>
        <p>We are now sending {{numberOfWinners}} email(s) to you with the title:</p>
        <p><strong>"[Important] Travel Package Redemption Instructions..."</strong></p>
        <p>These email(s) contain links for your winning bidder(s) to register their travel package from your event:</p>
        <p><strong>{{eventName}} on {{date eventDate}}</strong></p>
        <p>The email subject lines will contain the <strong>bidder's last name and package code.</strong></p>
        <p>Simply forward the corresponding email directly to your winning bidder. No changes to the email are required on your part.</p>
        <p style="color:red;"><strong>Important: the link containted in your winning bidder's email is a password to our online booking system. Anyone with a copy of the link will be able to use the respective travel package. The link must NOT be shared with anyone other than the winning bidder.</strong></p>
        <p>Thanks and have a great day!</p>
        <p>
        <span style="display:block;">The Booking Team</span>
        <span style="display:block;">Charity Getaways</span>
        </p>
        <p>
        <small><i>
        This is an automatically generated email from an unattended email inbox. <strong>Please do not reply directly to this email.</strong>
        </i></small>
        </p>
        </div>
        `;

        // construct email
        let output = Handlebars.compile(template);
        emailData.html = output(this.item);

        // send email
        try {
          await axios.post(
            "https://ejtw4r3nl5eoplt2qiussbc7pm0lspoz.lambda-url.us-east-1.on.aws/",
            {
              emailData,
            }
          );
          // explainer email admin notification
          await portalsApp
            .firestore()
            .collection("adminNotifications")
            .add({
              archived: false,
              dateAdded: new Date().toISOString().substring(0, 10),
              dateArchived: "",
              text: `[Explainer Email Sent - Admin Portal] Organization Name: ${this.item.organizationName},Event Name: ${this.item.eventName}, Recipient: ${this.item.eventContactEmail}`,
            });
          resolve();
        } catch (error) {
          console.log(error);
          this.$toast.error(`Error: this.onSendExplainerEmail() - ${error}`);
          reject(error);
        }
      });
    },
    async onSendCongratsEmail(winner) {
      if (
        !Object.values(this.item).length ||
        !this.item.winners.length ||
        !this.sendCongratsEmails ||
        !winner
      )
        return this.$toast.error("Error: onSendCongratsEmail()");

      if (this.congratsEmailDialog) this.loading = true;

      return new Promise(async (resolve, reject) => {
        // data for html template and nodemailer
        let emailData = {
          // subject is set below in function
          subject: `[Important] Travel Package Redemption Instructions (${
            winner.lastName
          } / ${winner.packageCode.toUpperCase()})`,
          to: [
            process.env.NODE_ENV.trim() == "development"
              ? ""
              : this.item.eventContactEmail,
          ],
          bcc: [
            process.env.NODE_ENV.trim() == "development"
              ? ""
              : "booking@silentauctionvacations.com",
          ],
          html: "",
        };

        // email template
        let template = `
        <div style="font-family: 'Roboto', sans-serif; max-width: 768px;"> <p style="font-size: 13px; line-height: 1.5;"> <small> <i> This is an automatically generated email from an unattended email inbox. <strong>Please do not reply directly to this email.</strong> </i> </small> </p><p style="font-size: 18px; font-family: garamond, 'times new roman', serif; line-height: 1.5;"><strong><i>Congratulations on winning your travel package with Charity Getaways!</i></strong></p><p style="font-size: 13px; line-height: 1.5;">Please use the link below to <strong>register your package and gain access to your Traveler Dashboard.</strong></p><p style="font-size: 13px; line-height: 1.5;">If the link is not clickable, please copy and paste it into a new browser window.</p><p style="color: red;font-size: 13px; line-height: 1.5;"><strong>THIS LINK IS A PASSWORD. DO NOT SHARE IT.</strong></p><p style="font-size: 13px; line-height: 1.5;">Anyone who has a copy of this link will be able to register and use your travel package.</p><p style="font-size: 13px;">Click or copy/paste the blue link below to proceed:</p><p style="font-size: 13px; line-height: 1.5;"> <strong><a href="https://savtravelerportal.com/register?puid={{packageID}}" target="_blank" style="color: #15c;"> https://savtravelerportal.com/register?puid={{packageID}}</a></strong> </p><p style="font-size: 13px; line-height: 1.5;">Once you have completed registration the above link will no longer be viable and you will receive an email providing a link to your Traveler Dashboard.</p><p style="font-size: 13px; line-height: 1.5;">We strongly recommend that you <strong>bookmark your Traveler Dashboard</strong> for your future use as soon as you have completed registration.</p><p style="font-size: 13px; line-height: 1.5;">For privacy, security, and record-keeping purposes, <strong>all communication</strong> regarding registered packages must go through the <strong>internal messaging system</strong> after logging into your Traveler Dashboard by clicking <i>"Contact Us".</i> </p><p style="font-size: 13px; line-height: 1.5;">If you experience any issues registering or logging into your Traveler Dashboard after registration, please contact us at <strong><a href="mailto:info@charitygetaways.com" style="color: #15c;">info@charitygetaways.com</a></strong></p><br/><p style="font-size: 13px; line-height: 1.5;">Thank you and have a great day!</p><p><span style="display: block; font-family: garamond, 'times new roman', serif; color: #3d85c6; font-size: 18px;     font-weight: bold;">Charity Getaways Booking Team</span></p><p><img width="259" height="129" src="https://ci3.googleusercontent.com/mail-sig/AIorK4ze3LzL2xZhQpwsSVKzv8R3F55KSRz0s4VSKgem95hNaIMNxVmZkP1gOx-LKBwTiZbEdP74KNA"></p><p style="font-size: 13px; line-height: 1.5;"> <small> <i> This is an automatically generated email from an unattended email inbox. <strong>Please do not reply directly to this email.</strong> </i> </small> </p></div>`;

        // construct email
        let output = Handlebars.compile(template);
        emailData.html = output(winner);

        // send email
        try {
          await axios.post(
            "https://ejtw4r3nl5eoplt2qiussbc7pm0lspoz.lambda-url.us-east-1.on.aws/",
            {
              emailData,
            }
          );
          // congrats email admin notification
          await portalsApp
            .firestore()
            .collection("adminNotifications")
            .add({
              archived: false,
              dateAdded: new Date().toISOString().substring(0, 10),
              dateArchived: "",
              text: `[Congrats Email Sent - Admin Portal] Winner Last Name: ${winner.lastName}, Organization Name: ${this.item.organizationName},Event Name: ${this.item.eventName}, Recipient: ${this.item.eventContactEmail}`,
            });
          if (this.congratsEmailDialog) {
            this.loading = false;
            this.congratsEmailDialog = false;
            this.sendCongratsEmails = false;
            this.$toast.success("Congrats Email Sent");
          }
          resolve();
        } catch (error) {
          if (this.congratsEmailDialog) this.loading = false;
          console.log(error);
          this.$toast.error(`Error: this.onSendCongratsEmail() - ${error}`);
          reject(error);
        }
      });
    },
    async onSendOriginalEmail() {
      if (!Object.values(this.item).length || !this.sendOriginalEmail)
        return this.$toast.error("Error: onSendOriginalEmail()");

      return new Promise(async (resolve, reject) => {
        // data for html template and nodemailer
        // Removed developer email
        let emailData = {
          subject: `[Event Report] ${this.item.organizationName} / ${this.item.eventName} - (#${this.item.eventReportNumber})`,
          to: [
            process.env.NODE_ENV.trim() == "development"
              ? ""
              : this.item.eventContactEmail,
          ],
          cc: [
            `${
              process.env.NODE_ENV.trim() != "development" &&
              this.item.sendToAuctioneerEmail &&
              this.item.auctioneerEmail
                ? this.item.auctioneerEmail
                : ""
            }${
              process.env.NODE_ENV.trim() != "development" &&
              this.item.sendToAdditionalEmail &&
              this.item.additionalEmail
                ? "," + this.item.additionalEmail
                : ""
            }`,
          ],
          bcc: [
            process.env.NODE_ENV.trim() == "development"
              ? ""
              : "booking@silentauctionvacations.com",
          ],
          html: "",
        };

        // email template
        let template = `<div style="font-family: 'Roboto', sans-serif;">
      <h2>You've successfully submitted your information for {{eventName}}</h2>
      <p><small><i>
      This is an automated message from an unattended email address.<strong> Please do not reply directly to this email.</strong>
      </i></small></p>
      <p>Please review your submission below. If you find any mistakes, please contact
      <a href='mailto:accounting@charitygetaways.com?subject=Invoice%20#{{eventReportNumber}}'>
      Accounting@charitygetaways.com</a></p>

      <p>A copy of this invoice has been emailed to:
      {{eventContactEmail}}
      {{#if sendToAuctioneerEmail}}
      , {{auctioneerEmail}}
      {{/if}}
      {{#if sendToAdditionalEmail}}
      , {{additionalEmail}}
      {{/if}}
      </p>

      <div style='display:flex;flex-wrap:wrap;margin-bottom:15px;'>
      <div style='margin-right:100px;'>
      <h3>Charity Getaways - Invoice</h3>
      <div>P.O. Box 160535</div>
      <div>Altamonte Springs, FL 32716</div>
      <div><a href='tel:4077451175'>(407) 745-1175</a></div>
      <div>
      <a href="mailto:accounting@charitygetaways.com?subject=Invoice%20#{{eventReportNumber}}">
      Accounting@charitygetaways.com</a></div>

      {{#if savSalesUsed}}
      <div>SAV Team Member:
      {{#if savSalesName}}
      {{savSalesName}}
      {{/if}}
      {{#if savSalesOtherName}}
      {{savSalesOtherName}}
      {{/if}}
      </div>
      {{/if}}

      </div>
      <div>
      <h3>Event Information</h3>
      <div>Organization Legal Name: {{organizationName}}</div>
      <div>Event Name: {{eventName}}</div>
      <div>Event Date: {{date eventDate}}</div>
      <div># of Winners: {{winners.length}}</div>
      </div>
      </div>

      <div style='display:flex;flex-wrap:wrap;margin-bottom:35px;'>

      <div style='margin-right:50px;'>
      <h3>Invoice Information</h3>
      <div>Invoice #: {{eventReportNumber}}</div>
      <div>Date Submitted: {{date dateCreated}}</div>
      <div>Invoice Total: <strong>{{currency eventReportTotal}}</strong></div>
      </div>

      {{#if auctioneerUsed}}
      <div style='margin-right:50px;'>
      <h3>Auctioneer Information</h3>
      <div>Name: {{auctioneerName}}</div>
      <div>Email: {{auctioneerEmail}}</div>
      <div>Company: {{auctioneerCompany}}</div>
      </div>
      {{/if}}

      <div>
      <h3>Contact Information</h3>
      <div>Name: {{eventContactFirstName}} {{eventContactLastName}}</div>
      <div>Email: {{eventContactEmail}}</div>
      <div>Phone: {{phone eventContactPhoneNumber}}</div>
      </div>
      </div>

      <h3>Winner Information</h3>
      <table style="border-collapse: collapse;margin-bottom:25px;">
      <tr style="text-align: left;">
      <th style="padding: 8px;border: 1px solid #dddddd;">Last Name</th>
      <th style="padding: 8px;border: 1px solid #dddddd;">Package Code</th>
      <th style="padding: 8px;border: 1px solid #dddddd;">Destination</th>
      <th style="padding: 8px;border: 1px solid #dddddd;">Unit Type</th>
      <th style="padding: 8px;border: 1px solid #dddddd;"># Nights</th>
      <th style="padding: 8px;border: 1px solid #dddddd;">Cost to Organization</th>
      </tr>
      {{#each winners}}
      <tr style="text-align: left;">
      <td style="padding: 8px;border: 1px solid #dddddd;">{{lastName}}</td>
      <td style="padding: 8px;border: 1px solid #dddddd;text-transform: uppercase;">{{packageCode}}</td>
      <td style="padding: 8px;border: 1px solid #dddddd;">{{truncate destination 40}}</td>
      <td style="padding: 8px;border: 1px solid #dddddd;">{{unitType}}</td>
      <td style="padding: 8px;border: 1px solid #dddddd;">{{numberNights}}</td>
      <td style="padding: 8px;border: 1px solid #dddddd;">{{currency costToOrg}}</td>
      </tr>
      {{/each}}
      </table>

      <div style='display:flex;flex-wrap:wrap;margin-bottom:15px;'>
      <div style='margin-right:100px;max-width:500px;'>
      <h3>Payment Information</h3>
      <div>This is your invoice. Please make payment to match the invoice total ({{currency eventReportTotal}}).
      Pay terms are within 30 days of event date.
      Upon receiving your payment we will email the winning bidders individual redemption email(s) to {{eventContactEmail}}.
      These email(s) contain all the information necessary for your winning bidder(s) to redeem their package. You must forward each redemption email to the individual winner.</div>
      </div>

      <div>
      <h3>Invoice Total - {{currency eventReportTotal}}</h3>
      <div><i>We will contact you after receiving your payment.</div>
      <div>Please make checks payable to:</i></div>
      <br/>
      <div><strong>Charity Getaways</strong></div>
      <div><strong>P.O. Box 160535</strong></div>
      <div><strong>Altamonte Springs, FL 32716</strong></div>
      </div>
      </div>

      <p>
      <small><i>
      This is an automated message from an unattended email address.<strong> Please do not reply directly to this email.</strong>
      </i></small>
      </p>

      <p><small>
      Today's Date: {{date ${new Date().toISOString().substring(0, 10)} }}
      </small></p>

      </div>`;

        // construct email
        let output = Handlebars.compile(template);
        emailData.html = output(this.item);

        // send email
        try {
          await axios.post(
            "https://ejtw4r3nl5eoplt2qiussbc7pm0lspoz.lambda-url.us-east-1.on.aws/",
            {
              emailData,
            }
          );
          // invoice email sent admin notification
          await portalsApp
            .firestore()
            .collection("adminNotifications")
            .add({
              archived: false,
              dateAdded: new Date().toISOString().substring(0, 10),
              dateArchived: "",
              text: `[Invoice Email Sent - Admin Portal] Event Name: ${this.item.eventName}, Recipients: ${this.item.eventContactEmail} ${this.item.auctioneerEmail} ${this.item.additionalEmail}`,
            });
          resolve();
        } catch (error) {
          console.log(error);
          this.$toast.error(`Error: this.onSendOriginalEmail() - ${error}`);
          reject(error);
        }
      });
    },
    async submitQuickActions() {
      if (!Object.values(this.item).length)
        return this.$toast.error("Error: item not found");

      this.loading = true;

      //  dateUpdated
      this.item.dateUpdated = new Date().toISOString().substring(0, 10);

      // parseFloat eventReportTotal
      this.item.eventReportTotal = parseFloat(this.item.eventReportTotal);

      const checkIdIdAvailable = await portalsApp
        .firestore()
        .collection("eventReports")
        .where("id", "==", this.item.id)
        .get();

      // set firestore doc
      await portalsApp
        .firestore()
        .collection("eventReports")
        .doc(this.item.id)
        .set(this.item, { merge: true });

      // QB Sync

      // if (!checkIdIdAvailable.docs.length) {
      //   // await this.quickBookSync(this.item.eventReportNumber);
      // }
      // if (this.item.isPaid) {
        // await this.quickBookDelete(this.item.eventReportNumber);
        // await this.quickBookSync(this.item.eventReportNumber);
        // this.quickBookUpdateSync(this.item.eventReportNumber);
      // }

      // send event report email
      if (this.sendOriginalEmail) await this.onSendOriginalEmail();

      // tennyson paid email
      if (this.tennysonEmail) await this.sendTennysonEmail();

      // send explainer email
      if (this.sendExplainerEmail) await this.onSendExplainerEmail();

      // send congrats emails
      if (this.sendCongratsEmails) {
        for (const winner of this.item.winners) {
          await this.onSendCongratsEmail(winner);
        }
      }

      // success
      // this.$toast.success("Event Report Saved");
      this.postTaskCleanUp();
    },
    async sendTennysonEmail() {
      if (!Object.values(this.item).length || !this.tennysonEmail)
        return this.$toast.error("Error: sendTennysonEmail()");

      return new Promise(async (resolve, reject) => {
        // data for html template and nodemailer
        // Removed developer email
        let emailData = {
          subject: `ATTN: Paid SAV Invoice for Accounting - [Event Report] ${this.item.organizationName} / ${this.item.eventName} - (#${this.item.eventReportNumber})`,
          to: [
            process.env.NODE_ENV.trim() == "development"
              ? ""
              : "accounting@charitygetaways.com",
          ],
          cc: [
            `${
              process.env.NODE_ENV.trim() != "development"
                ? "booking@silentauctionvacations.com"
                : ""
            }`,
          ],
          html: "",
        };

        // email template
        let template = `<div style="font-family: 'Roboto', sans-serif;">
      <h2>You've successfully submitted your information for {{eventName}}</h2>
      <p><small><i>
      This is an automated message from an unattended email address.<strong> Please do not reply directly to this email.</strong>
      </i></small></p>
      <p>Please review your submission below. If you find any mistakes, please contact
      <a href='mailto:accounting@charitygetaways.com?subject=Invoice%20#{{eventReportNumber}}'>
      Accounting@charitygetaways.com</a></p>

      <p>A copy of this invoice has been emailed to:
      {{eventContactEmail}}
      {{#if sendToAuctioneerEmail}}
      , {{auctioneerEmail}}
      {{/if}}
      {{#if sendToAdditionalEmail}}
      , {{additionalEmail}}
      {{/if}}
      </p>

      <div style='display:flex;flex-wrap:wrap;margin-bottom:15px;'>
      <div style='margin-right:100px;'>
      <h3>Charity Getaways - Invoice</h3>
      <div>P.O. Box 160535</div>
      <div>Altamonte Springs, FL 32716</div>
      <div><a href='tel:4077451175'>(407) 745-1175</a></div>
      <div>
      <a href="mailto:accounting@charitygetaways.com?subject=Invoice%20#{{eventReportNumber}}">
      Accounting@charitygetaways.com</a></div>

      {{#if savSalesUsed}}
      <div>SAV Team Member:
      {{#if savSalesName}}
      {{savSalesName}}
      {{/if}}
      {{#if savSalesOtherName}}
      {{savSalesOtherName}}
      {{/if}}
      </div>
      {{/if}}

      </div>
      <div>
      <h3>Event Information</h3>
      <div>Organization Legal Name: {{organizationName}}</div>
      <div>Event Name: {{eventName}}</div>
      <div>Event Date: {{date eventDate}}</div>
      <div># of Winners: {{winners.length}}</div>
      </div>
      </div>

      <div style='display:flex;flex-wrap:wrap;margin-bottom:35px;'>

      <div style='margin-right:50px;'>
      <h3>Invoice Information</h3>
      <div>Invoice #: {{eventReportNumber}}</div>
      <div>Date Submitted: {{date dateCreated}}</div>
      <div>Invoice Total: <strong>{{currency eventReportTotal}}</strong></div>
      </div>

      {{#if auctioneerUsed}}
      <div style='margin-right:50px;'>
      <h3>Auctioneer Information</h3>
      <div>Name: {{auctioneerName}}</div>
      <div>Email: {{auctioneerEmail}}</div>
      <div>Company: {{auctioneerCompany}}</div>
      </div>
      {{/if}}

      <div>
      <h3>Contact Information</h3>
      <div>Name: {{eventContactFirstName}} {{eventContactLastName}}</div>
      <div>Email: {{eventContactEmail}}</div>
      <div>Phone: {{phone eventContactPhoneNumber}}</div>
      </div>
      </div>

      <h3>Winner Information</h3>
      <table style="border-collapse: collapse;margin-bottom:25px;">
      <tr style="text-align: left;">
      <th style="padding: 8px;border: 1px solid #dddddd;">Last Name</th>
      <th style="padding: 8px;border: 1px solid #dddddd;">Package Code</th>
      <th style="padding: 8px;border: 1px solid #dddddd;">Destination</th>
      <th style="padding: 8px;border: 1px solid #dddddd;">Unit Type</th>
      <th style="padding: 8px;border: 1px solid #dddddd;"># Nights</th>
      <th style="padding: 8px;border: 1px solid #dddddd;">Cost to Organization</th>
      </tr>
      {{#each winners}}
      <tr style="text-align: left;">
      <td style="padding: 8px;border: 1px solid #dddddd;">{{lastName}}</td>
      <td style="padding: 8px;border: 1px solid #dddddd;text-transform: uppercase;">{{packageCode}}</td>
      <td style="padding: 8px;border: 1px solid #dddddd;">{{truncate destination 40}}</td>
      <td style="padding: 8px;border: 1px solid #dddddd;">{{unitType}}</td>
      <td style="padding: 8px;border: 1px solid #dddddd;">{{numberNights}}</td>
      <td style="padding: 8px;border: 1px solid #dddddd;">{{currency costToOrg}}</td>
      </tr>
      {{/each}}
      </table>

      <div style='display:flex;flex-wrap:wrap;margin-bottom:15px;'>
      <div style='margin-right:100px;max-width:500px;'>
      <h3>Payment Information</h3>
      <div>This is your invoice. Please make payment to match the invoice total ({{currency eventReportTotal}}).
      Pay terms are within 10 days of event date.
      Upon receiving your payment, we will email the winning bidders individual congratulations email to {{eventContactEmail}}.
      These email(s) contain all the information necessary for your winning bidder(s) to redeem their package. You must forward the information to the individual winners.</div>
      </div>

      <div>
      <h3>Invoice Total - {{currency eventReportTotal}}</h3>
      <div><i>We will contact you after receiving your payment.</div>
      <div>Please make checks payable to:</i></div>
      <br/>
      <div><strong>Charity Getaways</strong></div>
      <div><strong>P.O. Box 160535</strong></div>
      <div><strong>Altamonte Springs, FL 32716</strong></div>
      </div>
      </div>

      <p>
      <small><i>
      This is an automated message from an unattended email address.<strong> Please do not reply directly to this email.</strong>
      </i></small>
      </p>

      <p><small>
      Today's Date: {{date ${new Date().toISOString().substring(0, 10)} }}
      </small></p>

      </div>`;

        // construct email
        let output = Handlebars.compile(template);
        emailData.html = output(this.item);

        // send email
        // Tennyson email sent admin notification
        try {
          await axios.post(
            "https://ejtw4r3nl5eoplt2qiussbc7pm0lspoz.lambda-url.us-east-1.on.aws/",
            {
              emailData,
            }
          );

          await portalsApp
            .firestore()
            .collection("adminNotifications")
            .add({
              archived: false,
              dateAdded: new Date().toISOString().substring(0, 10),
              dateArchived: "",
              text: `[Invoice Paid Email Sent - Admin Portal] Event Name: ${this.item.eventName}, Recipients: accounting@charitygetaways.com`,
            });
          resolve();
        } catch (error) {
          console.log(error);
          this.$toast.error(`Error: this.sendTennysonEmail() - ${error}`);
          reject(error);
        }
      });
    },
    async submit() {
      if (!Object.values(this.item).length)
        return this.$toast.error("Error: item not found");

      if (!this.$refs.form.validate())
        return this.$toast.error("Please check form for errors");

      this.loading = true;

      //  dateUpdated
      this.item.dateUpdated = new Date().toISOString().substring(0, 10);

      // parseFloat eventReportTotal
      this.item.eventReportTotal = parseFloat(this.item.eventReportTotal);

      if (!this.editing) {
        // set eventReport id
        this.item.id = await this.getNextEventReportNumber();
        // set eventReportNumber
        this.item.eventReportNumber = parseInt(this.item.id.split("-")[0]);
        // set dates
        this.item.dateCreated = new Date().toISOString().substring(0, 10);
        this.item.dateUpdated = "";
      }

      // maintain winnerPackageIDs array
      this.item.winnerPackageIDs = this.item.winners.map((i) => i.packageID);

      const checkIdIdAvailable = await portalsApp
        .firestore()
        .collection("eventReports")
        .where("id", "==", this.item.id)
        .get();

      // set firestore doc
      await portalsApp
        .firestore()
        .collection("eventReports")
        .doc(this.item.id)
        .set(this.item, { merge: true });

      // QB Sync

      // if (!checkIdIdAvailable.docs.length) {
      //   await this.quickBookSync(this.item.eventReportNumber);
      //   this.item.isPaid &&
      //     this.quickBookUpdateSync(this.item.eventReportNumber);
      // }
      // if (checkIdIdAvailable.docs.length) {
      //   await this.quickBookDelete(this.item.eventReportNumber);
      //   await this.quickBookSync(this.item.eventReportNumber);
      //   this.item.isPaid &&
      //     this.quickBookUpdateSync(this.item.eventReportNumber);
      // }

      // send event report email
      if (this.sendOriginalEmail) await this.onSendOriginalEmail();

      // tennyson paid email
      if (this.tennysonEmail) await this.sendTennysonEmail();

      // send explainer email
      if (this.sendExplainerEmail) await this.onSendExplainerEmail();

      // send congrats emails
      if (this.sendCongratsEmails) {
        for (const winner of this.item.winners) {
          await this.onSendCongratsEmail(winner);
        }
      }

      // success
      // this.$toast.success("Event Report Saved");
      this.postTaskCleanUp();
    },
    async onQuickActions(item) {
      if (!Object.values(item).length)
        return this.$toast.error("item not found");

      this.loading = true;
      NProgress.start();
      let doc = await this.getDoc(item.id);
      // let doc = await this.getDoc("660-1-20220207-153226");

      if (!doc.id) {
        this.$toast.error("Event report not found in database");
        this.loading = false;
        NProgress.done();
        return;
      }

      this.item = doc;
      this.preSaveActionsDialog = true;
      this.loading = false;
      NProgress.done();
    },
    async setWinnerInfo(
      index,
      { destination, costToOrg, roomType, numberNights, packageCode }
    ) {
      // setting display values
      this.item.winners[index].destination = destination;
      this.item.winners[index].costToOrg = costToOrg;
      this.item.winners[index].unitType = roomType.title;
      this.item.winners[index].numberNights = numberNights;
      this.item.winners[index].packageCode = packageCode;
      this.item.winners[index].packageCode = packageCode;

      // format and set PUID
      let puid = packageCode.toLowerCase();
      puid = puid.replaceAll("-", "");
      puid = puid.replaceAll("sav", "");
      puid = puid.replaceAll("golf", "");
      puid = moment(new Date()).format("MM-DD-YYYY-hh-mm-ssSSS-") + puid;
      puid = puid.replaceAll(" ", "").trim();
      this.item.winners[index].packageID = puid;

      // set winner travelByDate if eventDate set
      if (this.item.eventDate) {
        let travelByDate = moment(this.item.eventDate)
          .startOf("day")
          .add(3, "y")
          .subtract(numberNights, "days")
          .toISOString()
          .substring(0, 10);
        this.item.winners[index].travelByDate = travelByDate;
      }
    },
    scrollToLastWinner() {
      // scrolls screen to see new winner added
      if (!Object.values(this.item).length) return;
      setTimeout(() => {
        let length = this.item.winners.length - 2;
        let el = document.getElementById(`winner-${length}`);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 200);
    },
    async getNextEventReportNumber() {
      // get last event report number and add 1
      // format = nextEventReportNumber-numberWinners-dateValue-timeValue
      return new Promise((resolve, reject) => {
        let nextEventReportNumber =
          this.items.sort(
            (a, b) => b.eventReportNumber - a.eventReportNumber
          )[0].eventReportNumber + 1;

        let newDate = new Date().toISOString();
        let dateValue = newDate
          .split("T")[0]
          .replace(/-/g, "")
          .trim();

        let timeValue = newDate
          .split("T")[1]
          .split(".")[0]
          .replace(/:/g, "")
          .trim();

        if (nextEventReportNumber && dateValue && timeValue) {
          let nextNumber =
            nextEventReportNumber +
            "-" +
            this.item.winners.length +
            "-" +
            dateValue +
            "-" +
            timeValue;
          resolve(nextNumber);
        }

        reject("error creating event report id");
      });
    },
    getDoc(id) {
      if (!id) return false;
      return portalsApp
        .firestore()
        .collection("eventReports")
        .doc(id)
        .get()
        .then((doc) => {
          if (doc.exists) return doc.data();
          return false;
        })
        .catch((err) => {
          this.$toast.error(err);
          return false;
        });
    },
    async onEdit(item) {
      if (!Object.values(item).length) return;

      // ensuring the correct table row is opened
      this.expanded = [];
      this.expanded.push(item);

      NProgress.start();
      this.loading = true;

      // getting doc
      // let doc = await this.getDoc("660-1-20220207-153226");
      let doc = await this.getDoc(item.id);

      // doc exists
      if (doc) {
        this.item = doc;
        this.itemDialog = true;
        this.editing = true;
        this.loading = false;
        NProgress.done();
        return;
      }

      // !doc
      this.$toast.error("item not found in database");
      this.item = {};
      this.itemDialog = false;
      this.editing = false;
      this.loading = false;
      NProgress.done();
      return;
    },
  },
  watch: {
    "$store.state.eventReports": {
      immediate: true,
      handler(val) {
        if (val.length != 0) return (this.loading = false);
      },
    },
    // watches route to open event report
    "$route.query.q": {
      deep: true,
      immediate: true,
      async handler(q) {
        if (q == undefined || q == null) return;
        return await this.onEdit({ id: q });
      },
    },
    // calculates event report total
    // maintains item.numberOfWinners
    "item.winners": {
      deep: true,
      handler(val) {
        if (val == undefined) return;
        if (this.editing && !this.dirty) return;
        let total = this.item.winners.map((i) => {
          if (i.costToOrg == "" || isNaN(i.costToOrg)) return 0;
          return parseFloat(i.costToOrg);
        });
        this.item.eventReportTotal = total.reduce((a, b) => a + b);
        this.item.numberOfWinners = val.length;
      },
    },
    // adds travelByDate to eventReport (+3 years)
    // adds travelByDate to each winner if winner has numberNights set
    "item.eventDate"(val) {
      if (!val || val == undefined) return;
      this.item.travelByDate = moment(val)
        .startOf("day")
        .add(3, "y")
        .toISOString()
        .substring(0, 10);

      if (this.item.winners.length) {
        this.item.winners.forEach((item, index) => {
          if (!item.numberNights) return;
          this.item.winners[index].travelByDate = moment(val)
            .startOf("day")
            .add(3, "y")
            .subtract(item.numberNights, "days")
            .toISOString()
            .substring(0, 10);
        });
      }
    },
    // resets paid to false if dialog closes without a date paid entered
    datePaidDialog(val) {
      if (val == undefined || val == null) return;
      if (!val && !this.item.datePaid) return (this.item.isPaid = false);
    },
    // resets scroll position inside itemDialog when opened or closed
    itemDialog(val) {
      if (val == undefined || val == null) return;
      setTimeout(() => {
        let el = document.getElementById("top");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 200);
    },
  },
};
</script>

<style>
td {
  cursor: pointer;
}
</style>
